export const environment = {
  production: false,
  // apiUrl: 'https://globalsources-erp-staging-26029169.dev.odoo.com/odoo'
    apiUrl: 'https://globalsources-erp-staging-33168767.dev.odoo.com/odoo'
  //  apiUrl: 'https://globalsources-erp.odoo.com/odoo'
};
